<template>
    <div class="col-12">
        <div style="margin-bottom: 120px">
          <div class="row step-back">
            <div class="col-xs-12 col-md-5 text-left">
              <button @click="returnStep2" class="btn btn-return">
                <i class="fas fa-caret-left"></i> {{ $t('message.backToContact') }}
              </button>
            </div>
          </div>
          <div class="row mt-4 mb-4"
               v-if="countMembers() > 0 && this.showMember === null && this.showNewCart === false">
                <div class="col-xs-12 col-md-6 p-3" v-for="(member, index) in this.$root.$store.state.members"
                     :key="'member-'+index">
                    <div class="col border border-gray m-1 p-1 bg-light shadow-sm" style="border-radius: 0.8rem">
                        <div class="text-left ml-4">
                            <strong class="mr-2">
                                {{member.last_name}} {{member.first_name}}
                            </strong>
                            <small>
                                <template v-if="$root.serviceSetting.input_type_age === 'button'">
                                  <span class="text-info">{{$t($t('message.age' + member.age))}}</span>&nbsp;/
                                </template>
                                <template v-else>
                                  <span class="text-info">{{member.age}} {{$t('歳')}}</span>&nbsp;/
                                </template>
                                <span class="text-info">{{member.height}} cm</span>&nbsp;/
                                <span class="text-info">{{shoeFormatted(member.shoe)}}</span>&nbsp;
                            </small>
                        </div>
                        <hr>
                        <!-- rentalItems -->
                        <div class="text-left ml-4">
                            [{{$t($t('message.item' + member.item.slice(0,1).toUpperCase() + member.item.slice(1)))}}
                            {{$t(member.itemCategoryName)}}] <span v-if="member.itemCategoryPrice > 0">￥ {{member.itemCategoryPrice | numberFormat}}</span>
                            <div v-for="(i, ind) in member.rentalItems" :key="ind">{{$t(i.name)}} ￥{{i.price | numberFormat}}</div>
                        </div>
                        <hr>
                        <div class="text-right">
                          <div v-if="!stockModelParam.members[index] || stockModelParam.members[index].nowLoading !== false" class="m-3"><i class="fas fa-spinner fa-spin"></i></div>
                          <div v-if="stockModelParam.cartErrors.hasOwnProperty(index)" class="text-danger m-3">{{$t(stockModelParam.cartErrors[index])}}</div>
                          <button type="button" class="btn btn-info mr-4 rounded-pill"
                                  @click="setMember(index)"><i class="fas fa-pencil-alt"></i> {{$t('編集する')}}
                          </button>
                          <button v-if="!member.isRepresentative" type="button" class="btn btn-secondary rounded-pill"
                                  @click="removeMember(index)"><i class="fas fa-close"></i> {{$t('削除する')}}
                          </button>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-md-6 p-3">
                    <button @click="newCart" class="btn btn-block btn-lg bg-warning btn-h-auto" style="height: 6rem"
                            v-if="countMembers() > 0 && countMembers() < this.$root.$store.state.memberLimit"><i class="fas fa-plus fa-2x"></i> {{$t('カートに追加する')}}
                    </button>
                </div>
                <div class="col m-3" style="font-size:135%" v-if="countMembers() < this.$root.$store.state.memberLimit">
                    <div v-if="this.$root.$i18n.locale === 'en'" class="text-center">
                        For the second and subsequent applications,
                        <span class="bg-warning">
                            "Add cart"
                            </span>
                    </div>
                    <div v-if="this.$root.$i18n.locale === 'cn'" class="text-center">
                        对于第二个及其后的应用程序，
                        <span class="bg-warning">
                            "添加购物车"
                            </span>
                    </div>
                    <div v-if="this.$root.$i18n.locale === 'ja'" class="text-center">
                        2人目以降の申し込みは、
                        <span class="bg-warning">
                            <strong class="">「カートに追加する」</strong>
                            </span>
                        から行えます
                    </div>
                </div>
            </div>
            <div class="row" v-if="countMembers() === 0 || this.showNewCart === true">
                <Member @correct="addCart" :mode="'add'" ref="newMember" @back-to-cart="showCartIndex"
                        :currentCount="countMembers()"></Member>
            </div>
            <div class="row" v-if="showMember !== undefined && showMember != null">
                <Member @correct="updateCart" ref="editMember" :mode="'update'" @back-to-cart="showCartIndex"
                        :current="this.current"></Member>
            </div>
          <div v-if="Object.keys(stockModelValue.outOfStocks).length > 0 && this.$root.$route.query.debug === '1'">
            <hr>
            <div v-for="(value, key) in stockModelValue.outOfStocks" :key="key" class="text-danger m-3">
              {{$t(value.name)}}
            </div>
          </div>
        </div>

        <div class="row" v-if="this.showMember === null && this.showNewCart === false && countMembers() > 0">
            <hr>
            <div class="col fixed-bottom m-0 mt-4 mb-4" style="background: rgba(255,255,255,0.8)">
                <div class="row">
                    <div class="col-md-6 col-12">
                        <template v-if="countMembers() > 0 && this.showMember === null && this.showNewCart === false">
                            <div style="font-size: 2rem;vertical-align: middle">
                                {{$t('金額合計')}} ￥ {{priceTotal}}
                            </div>
                        </template>
                    </div>
                    <div class="col-12 col-md-6" v-if="itemExists">
                      <template v-if="stockModelParam.cartChecked && Object.keys(stockModelParam.cartErrors).length === 0">
                        <button @click="goToStep4" class="btn btn-lg btn-primary btn-h-6 design4 btn-3d btn-block">
                          {{$t('message.goToConfirm')}} <i class="fas fa-arrow-right"></i>
                        </button>
                      </template>
                      <template v-else-if="!stockModelParam.cartChecked">
                        <button class="btn btn-lg btn-primary btn-h-6 design4 btn-3d btn-block disabled">
                          <i class="fas fa-spin fa-spinner"></i>
                        </button>
                      </template>
                      <template v-else>
                        <button class="btn btn-lg btn-primary btn-h-6 design4 btn-3d btn-block disabled">
                          <i class="fas fa-exclamation-triangle"></i> {{$t('message.btn.outOfStock')}}
                        </button>
                      </template>
                    </div>
                  <div class="col-12 col-md-6" v-if="!itemExists">
                    <button class="btn btn-lg btn-primary btn-h-6 design4 btn-3d btn-block disabled" disabled>
                      <i class="fas fa-exclamation-triangle"></i> {{$t('アイテムを選択してください')}}
                    </button>
                  </div>
                    <!-- <div class="col-lg-3 col-6">
                        <button @click="goToStep4" class="btn btn-lg btn-primary btn-h-6">
                            {{$t('message.goToConfirm')}}
                        </button>
                    </div>
                    <div class="col-lg-3 col-6">
                        <button @click="goToStep6" class="btn btn-lg btn-primary btn-h-6 ml-4">事前決済</button>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import Underscore from 'vue-underscore'
import Member from '../components/Member.vue'
import StockModel from '../mixins/stock.js'

Vue.use(Underscore)

export default {
  name: 'Cart',
  data () {
    return {
      showMember: null,
      showNewCart: false,
      current: {}
    }
  },
  mixins: [StockModel],
  computed: {
    priceTotal () {
      let m = this.$root.$store.state.members
      let total = 0
      m.forEach((t, index) => {
        let items = t.rentalItems
        if (parseInt(t.itemCategoryPrice) > 0) {
          total += parseInt(t.itemCategoryPrice)
        }
        if (items) {
          this.$_.each(items, function (item, index) {
            total += parseInt(item.price)
          })
        }
      })
      let formatter = new Intl.NumberFormat('ja-JP')
      return formatter.format(total)
    },
    itemExists () {
      let m = this.$root.$store.state.members
      let total = 0
      m.forEach((t, index) => {
        let items = t.rentalItems
        if (parseInt(t.itemCategoryPrice) > 0) {
          total += parseInt(t.itemCategoryPrice)
        }
        if (items) {
          this.$_.each(items, function (item, index) {
            total += parseInt(item.price)
          })
        }
      })
      if (total > 0) {
        return true
      }
      return false
    }
  },
  filters: {
    numberFormat (value) {
      let isString = (typeof value === 'string' || value instanceof String)
      if (value === undefined) {
        return null
      }
      if (isString) {
        return value
      }
      if (isNaN(value) && !value.match(/^\d+$/)) {
        return value
      }
      let formatter = new Intl.NumberFormat('ja-JP')
      return formatter.format(value)
    }
  },
  mounted () {
    // console.log('step3')
    window.sendGtag({
      'page_path': '/reserve-app/step3'
    })
    window.scrollTo({ top: 0, behavior: 'smooth' })
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
    this.getStockAndCheck()
  },
  components: { Member },
  methods: {
    async getStockAndCheck () {
      await this.getStockList(true).then(() => {
        if (this.countMembers() > 0) {
          this.stockCheck()
        }
      })
    },
    async stockCheck () {
      this.out('stockCheck')
      let members = this.$root.$store.state.members
      this.stockModelParam.members = {}
      this.stockModelParam.cartChecked = false
      this.stockModelParam.cartErrors = {}
      this.stockModelValue.outOfStocks = {}

      // membersの数だけ checkStockByMemberを実行
      for (let i = 0; i < members.length; i++) {
        this.out('---------------- メンバーごとのstockのチェック開始' + i, 0)
        await this.checkStockByMember(members[i], i).then(() => {
          this.out('---------------- メンバーごとのstockのチェック終了' + i, 0)
        })
      }
      this.stockModelParam.cartChecked = true
    },
    shoeFormatted (val) {
      let v = parseInt(val)
      if (v > 0) {
        return (v / 10).toFixed(1) + ' cm'
      }
      return null
    },
    showCartIndex (index) {
      // console.log('showCartIndex', index)
      this.showMember = null
      this.showNewCart = false
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    setMember (index) {
      // console.log('setMember', index)
      this.showMember = index
      this.current = this.$root.$store.state.members[this.showMember]
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    removeMember (index) {
      var members = this.$root.$store.state.members
      members.splice(index, 1)
      members = this.$root.serviceSetting.enable_name.value === 'true' ? members : this.reName(members)
      this.$root.$store.commit('update', { field: 'members', value: members })
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    newCart () {
      this.showNewCart = true
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    returnStep2 (e) {
      this.$root.$store.commit('update', { field: 'step', value: 2 })
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    goToStep4 (e) {
      this.$root.$store.commit('update', { field: 'step', value: 4 })
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    countMembers () {
      let members = this.$_.size(this.$root.$store.state.members)
      // console.log('members', members)
      if (members > 0 && this.$root.$store.state.members?.[0]?.item === '') {
        // console.log('setMember(0)', this.$root.$store.state.members[0])
        this.setMember(0)
      }
      return members
    },
    addCart (member) {
      let members = []
      if (this.countMembers() > 0) {
        members = this.$root.$store.state.members
      }
      members.push(member)
      this.$root.$store.commit('update', { field: 'members', value: members })
      this.showNewCart = false
      this.showMember = null
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
      this.getStockAndCheck()
    },
    cancelCart () {

    },
    updateCart (member) {
      var members = this.$root.$store.state.members
      members.splice(this.showMember, 1, member)

      members = this.$root.serviceSetting.enable_name.value === 'true' ? members : this.reName(members)
      this.$root.$store.commit('update', { field: 'members', value: members })
      this.showNewCart = false
      this.showMember = null
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
      this.getStockAndCheck().then(() => {
        this.$forceUpdate()
      })
    },
    reName (members) {
      if (this.$root.$store.state.optionValues.enableName) {
        return members
      } else {
        var array = []
        var representative = ''
        for (let i = 0; i < members.length; i++) {
          let member = this.$root.$store.state.members[i]
          if (i === 0) {
            representative = member.last_name + member.first_name
          } else {
            member.last_name = representative
            member.first_name = i + 1 + '人め'
          }
          array.push(member)
        }
        return array
      }
    }
  }
}
</script>
